import React from 'react'

function ServicePolicy() {
  return (
    <div className=' p-4'>
        <h2>SERVICE POLICY</h2>

        <h3>Technology Services</h3>
        <ul>
          <li>99.9% uptime guarantee</li>
          <li>24/7 support</li>
          <li>Security updates</li>
        </ul>

        <h3>Organic Food Services</h3>
        <ul>
          <li>Freshness guarantee</li>
          <li>Delivery within 48 hours</li>
          <li>Allergen labeling</li>
        </ul>

        <h3>Construction Services</h3>
        <ul>
          <li>Project timelines</li>
          <li>Safety compliance</li>
          <li>Warranty included</li>
        </ul>

        <h3>Travel Services</h3>
        <ul>
          <li>Booking confirmation within 24h</li>
          <li>24/7 support</li>
          <li>Travel insurance required</li>
        </ul>

        <hr />

        <h3>CONTACT INFORMATION</h3>
        <p>
          <strong>Email:</strong> info@burgeon-grp.com
        </p>
    </div>
  )
}

export default ServicePolicy